<template>
    <noscript><div><img src="https://mc.yandex.ru/watch/91177235" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
</template>

<script>
export default {
  name: 'YaMetrika',
  props: {
    manualHit: Boolean,
  },
  mounted() {
    /* eslint-disable */
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(91177235, "init", {
      defer: true,
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
    });
    /* eslint-enable */

    if (!this.manualHit) {
      this.hit();
    }
  },
  methods: {
    hit() {
      // eslint-disable-next-line
      ym(91177235, 'hit', this.$route.fullPath);
    },
  },
};
</script>

<style scoped>

</style>
